/* eslint-disable no-restricted-imports */
import { agreementsEndpoints } from '../../../apps/services/agreements/lambdas/agreementsEndpoints'
import { assessmentEndpoints } from '../../../apps/services/assessments/lambdas/assessmentsEndpoints'
import { budgetApprovalsEndpoints } from '../../../apps/services/budget-approvals/lambdas/budgetApprovalsEndpoints'
import { budgetEndpoints } from '../../../apps/services/budgets/lambdas/budgetEndpoints'
import { commentEndpoints } from '../../../apps/services/comments/lambdas/commentsEndpoints'
import { configEndpoints } from '../../../apps/services/config/lambdas/configEndpoints'
import { contactsEndpoints } from '../../../apps/services/contacts/lambdas/contactsEndpoints'
import { coreEndpoints } from '../../../apps/services/core/lambdas/coreEndpoints'
import { coreDataEndpoints } from '../../../apps/services/core-data/lambdas/coreDataEndpoints'
import { customFieldsEndpoints } from '../../../apps/services/custom-fields/lambdas/customFieldsEndpoints'
import { documentsEndpoints } from '../../../apps/services/documents/lambdas/documentsEndpoints'
import { exportJobsEndpoints } from '../../../apps/services/export-jobs/lambdas/exportJobsEndpoints'
import { formTemplatesEndpoints } from '../../../apps/services/form-templates/lambdas/formTemplatesEndpoints'
import { intakeEndpoints } from '../../../apps/services/intake/lambdas/intakeEndpoints'
import { loginEndpoints } from '../../../apps/services/login/lambdas/loginEndpoints'
import { oneSchemaEndpoints } from '../../../apps/services/oneschema/lambdas/oneSchemaEndpoints'
import { orgSettingsEndpoints } from '../../../apps/services/org-settings/lambdas/orgSettingsEndpoints'
import { productsEndpoints } from '../../../apps/services/products/lambdas/productsEndpoints'
import { publicApiMgmtEndpoints } from '../../../apps/services/public-api-mgmt/lambdas/publicApiMgmtEndpoints'
import { punchoutCataloguesEndpoints } from '../../../apps/services/punchout-catalogues/lambdas/punchoutCataloguesEndpoints'
import { purchaseOrdersEndpoints } from '../../../apps/services/purchase-orders/lambdas/purchaseOrdersEndpoints'
import { receiptsEndpoints } from '../../../apps/services/receipts/lambdas/receiptsEndpoints'
import { renewalEndpoints } from '../../../apps/services/renewals/lambdas/renewalsEndpoints'
import { reportingEndpoints } from '../../../apps/services/reporting/lambdas/reportingEndpoints'
import { requestEndpoints } from '../../../apps/services/requests/lambdas/requestsServiceEndpoints'
import { rfxEndpoints } from '../../../apps/services/rfx/lambdas/rfxEndpoints'
import { risksEndpoints } from '../../../apps/services/risks/lambdas/risksEndpoints'
import { subprocessorsEndpoints } from '../../../apps/services/subprocessors/lambdas/subprocessorsEndpoints'
import { suppliersEndpoints } from '../../../apps/services/suppliers/lambdas/suppliersEndpoints'
import { tagsEndpoints } from '../../../apps/services/tags/lambdas/tagsEndpoints'
import { userEndpoints } from '../../../apps/services/users/lambdas/usersEndpoints'
import { workflowsEndpoints } from '../../../apps/services/workflows/lambdas/workflowsEndpoints'
import { workosEndpoints } from '../../../apps/services/workos/lambdas/workosEndpoints'

const apiRootUrl = process.env.NODE_ENV === 'test' ? 'http://localhost' : process.env.API_ROOT_URL
const apiAiFormRootUrl = process.env.NODE_ENV === 'test' ? 'http://localhost' : process.env.API_AI_FORM_ROOT_URL

export type ServiceKey = keyof typeof ServiceUrls

export const ServiceUrls = {
  AI_CHAT: `${apiRootUrl}/ai-chat`,
  AUDIT_LOG: `${apiRootUrl}/audit-log`,
  AUTH: `${apiRootUrl}/auth`,
  SLACK: `${apiRootUrl}/slack`,
  ACCOUNTING: `${apiRootUrl}/accounting`,
  EXTERNAL: `${apiRootUrl}/external`,
  EXTERNAL_OPERATION: `${apiRootUrl}/extops`,
  NOTIFICATIONS: `${apiRootUrl}/notifications`,
  INTEGRATIONS_V2: `${apiRootUrl}/integrations`,
  ESIGN: `${apiRootUrl}/esign`,
  USERS: `${apiRootUrl}/users`,
  CORE: apiRootUrl,
  PUBLIC_MGMT: `${apiRootUrl}/public-mgmt`,
  ASSESSMENTS: `${apiRootUrl}/assessments`,
  NEXT_PUBLIC: process.env.NEXT_PUBLIC_BASE_PATH,
  // FILE_STORAGE is the external file storage service, documents is the internal hasura file store
  FILE_STORAGE: `${apiRootUrl}/file-storage`,
  DOCUMENTS: `${apiRootUrl}/documents`,
  CONTACTS: `${apiRootUrl}/contacts`,
  RENEWALS: `${apiRootUrl}/renewals`,
  FORM_TEMPLATES: `${apiRootUrl}/form_templates`,
  INTAKES: `${apiRootUrl}/intakes`,
  RISKS: `${apiRootUrl}/risks`,
  REQUESTS: `${apiRootUrl}/requests`,
  CORE_DATA: `${apiRootUrl}/core-data`,
  COMMENTS: `${apiRootUrl}/comments`,
  CONFIG: `${apiRootUrl}/config`,
  PRODUCTS: `${apiRootUrl}/products`,
  CUSTOM_FIELDS: `${apiRootUrl}/custom-fields`,
  FIELDS: `${apiRootUrl}/fields`,
  BUDGET_APPROVALS: `${apiRootUrl}/budget-approvals`,
  BUDGETS: `${apiRootUrl}/budgets`,
  SUBPROCESSORS: `${apiRootUrl}/subprocessors`,
  SUPPLIERS: `${apiRootUrl}/suppliers`,
  LOGIN: `${apiRootUrl}/login`,
  RFX: `${apiRootUrl}/rfx`,
  PUNCHOUT_CATALOGUES: `${apiRootUrl}/punchout-catalogues`,
  PURCHASE_ORDERS: `${apiRootUrl}/purchase-orders`,
  RECEIPTS: `${apiRootUrl}/receipts`,
  TASKS: `${apiRootUrl}/tasks`,
  AGREEMENTS: `${apiRootUrl}/agreements`,
  REPORTING: `${apiRootUrl}/reporting`,
  OCR: `${apiRootUrl}/ocr`,
  ORGANISATIONS: `${apiRootUrl}/organisations`,
  TEAMS_APP: `${apiRootUrl}/ms-teams`,
  TPRM_CONTINUOUS_MONITORING: `${apiRootUrl}/tprm-continuous-monitoring`,
  SLACK_APP: `${apiRootUrl}/slack`,
  WORKOS: `${apiRootUrl}/workos`,
  ONESCHEMA: `${apiRootUrl}/oneschema`,
  ORG_SETTINGS: `${apiRootUrl}/org-settings`,
  TAGS: `${apiRootUrl}/tags`,
  WORKFLOWS: `${apiRootUrl}/workflows`,
  EXPORT_JOBS: `${apiRootUrl}/export-jobs`,
  API_AI_FORM: apiAiFormRootUrl,
} as const
type EndpointId = string
export type ApiServiceDefinition = Record<EndpointId, { method: string; path: string }>
export type EndpointDefinition = { method: string; path: string }

export const OmneaAppServiceEndpoints = {
  CORE: coreEndpoints,
  PUBLIC_MGMT: publicApiMgmtEndpoints,
  COMMENTS: commentEndpoints,
  ASSESSMENTS: assessmentEndpoints,
  CORE_DATA: coreDataEndpoints,
  DOCUMENTS: documentsEndpoints,
  CONTACTS: contactsEndpoints,
  RENEWALS: renewalEndpoints,
  FORM_TEMPLATES: formTemplatesEndpoints,
  INTAKES: intakeEndpoints,
  RISKS: risksEndpoints,
  REQUESTS: requestEndpoints,
  CONFIG: configEndpoints,
  PRODUCTS: productsEndpoints,
  CUSTOM_FIELDS: customFieldsEndpoints,
  BUDGET_APPROVALS: budgetApprovalsEndpoints,
  BUDGETS: budgetEndpoints,
  SUBPROCESSORS: subprocessorsEndpoints,
  SUPPLIERS: suppliersEndpoints,
  LOGIN: loginEndpoints,
  USERS: userEndpoints,
  RFX: rfxEndpoints,
  PUNCHOUT_CATALOGUES: punchoutCataloguesEndpoints,
  PURCHASE_ORDERS: purchaseOrdersEndpoints,
  RECEIPTS: receiptsEndpoints,
  AGREEMENTS: agreementsEndpoints,
  REPORTING: reportingEndpoints,
  WORKOS: workosEndpoints,
  ONESCHEMA: oneSchemaEndpoints,
  ORG_SETTINGS: orgSettingsEndpoints,
  TAGS: tagsEndpoints,
  WORKFLOWS: workflowsEndpoints,
  EXPORT_JOBS: exportJobsEndpoints,
}

/** APIs deployed as part of the Omnea App core stack */
export type OmneaAppServiceKeys = keyof typeof OmneaAppServiceEndpoints
